module.exports = __webpack_public_path__ + "static/media/tickmark-blue-medium-100.339418a8.svg";